import { parseDriverSelection } from "../../../utils/driverSelection";
import React, { useState } from "react";
import Loader from "../../../Components/Loader/Loader";
import PercentageLoader from "../../../Components/PercentageLoader/Loader";
import { toast } from "react-toastify";
import {
  updateExpense,
  fetchActivityData,
  fetchExtraPreps,
  fetchActivityReceipts,
  fetchACtivityAttachments,
  fetchFeeTypes,
  uploadReceipt,
  uploadAttachment,
  deleteReceipts,
  deleteProcessingReceipts,
  updateActivity,
  fetchDrivers,
  fetchPaymentMethods,
  createExpense,
  deleteExpense,
  deleteAttachment,
  fetchUploadedReceipts,
} from "../../../Redux/Actions/Activity";
import { handleResponse } from "../../../utils/Notification";
import CostEditForm from "../../../Components/Expense/Form";
import mask from "../../../utils/mask";
import { convertToMonthDayYear } from "../../../utils/common";
import { Link, useHistory } from "react-router-dom";
import "./form.scss";
import Modal from "react-modal";
import FixedScrollHeader from "../FixedScrollHeader";
import TextareaAutosize from "react-textarea-autosize";
import { useQuery, useMutation } from "react-query";

const customModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

const updationKeys = [
  "damage",
  "start_mileage",
  "end_mileage",
  "exterior_checklist",
  "interior_checklist",
  "driving_test",
  "extra_prep_type_id",
  "driver_id",
];

Modal.setAppElement("#root");

const Form = ({ ...props }) => {
  const [activityData, setActivityData] = useState({});
  const [costData, setCostData] = useState({ payment_method_id: 6 });
  const [editACtivity, setEditActivity] = useState({});
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isSaving, setIsSaving] = useState(false);
  const savingRef = React.useRef(false);
  const history = useHistory();

  const queryParams = new URLSearchParams(window.location.search);
  const queryParamsSelectedOffice = queryParams.get("selected_office");
  const queryParamsSelectedDate = queryParams.get("selected_date");

  const attachmentRef = React.useRef();
  const receiptRef = React.useRef();

  // Get Activity Data
  const { refetch: refetchActivityData, isFetching: _isFetchingActivityData } =
    useQuery(
      ["activityData"],
      async (_key) => {
        return await fetchActivityData(props.match.params.id);
      },
      {
        onSuccess: ({ data }) => {
          setActivityData(data);
        },
        onError: (error) => {
          handleResponse(error);
        },
      }
    );

  // Get Preps Data
  const { data: preps, isFetching: _isFetchingPrepData } = useQuery(
    ["preps"],
    async (_key) => {
      return await fetchExtraPreps();
    },
    {
      initialData: [],
      onError: (error) => {
        handleResponse(error);
      },
    }
  );

  // Get Fee Data
  const {
    data: { data: feeTypes, isFetching: _isFetchingFeeData },
  } = useQuery(
    ["feeTypes"],
    async (_key) => {
      return fetchFeeTypes({ activity_id: activityData?.activity_id });
    },
    {
      enabled: !!activityData?.activity_id,
      initialData: { data: [] },
      onError: (error) => {
        handleResponse(error);
      },
    }
  );

  // Get Payment Methods Data
  const {
    data: { data: paymentMethods, isFetching: _isFetchingPaymentData },
  } = useQuery(
    ["paymentMethods"],
    async (_key) => {
      return await fetchPaymentMethods();
    },
    {
      initialData: { data: [] },
      onError: (error) => {
        handleResponse(error);
      },
    }
  );

  // Get Attachment Data
  const {
    data: { data: attachments, isFetching: _isFetchingAttachmentData },
    refetch: refetchAttachments,
  } = useQuery(
    ["attachments"],
    async (_key) => {
      return await fetchACtivityAttachments({
        activity_id: activityData?.activity_id,
      });
    },
    {
      enabled: !!activityData?.activity_id,
      initialData: { data: [] },
      onError: (error) => {
        handleResponse(error);
      },
    }
  );

  // Get Receipt Data
  const {
    data: { data: receipts, isFetching: _isFetchingReceiptData },
    refetch: refetchReceipts,
  } = useQuery(
    ["receipts"],
    async (_key) => {
      return await fetchActivityReceipts({
        activity_detail_id: activityData?.activity_detail_id, // TODO: This may be wrong?
      });
    },
    {
      enabled: !!activityData.activity_detail_id,
      initialData: { data: [] },
      onError: (error) => {
        handleResponse(error);
      },
    }
  );

  // Get Uploaded Receipt Data
  const {
    data: { data: uploadedReceipts },
    refetch: refetchUploadedReceipts,
  } = useQuery(
    ["uploadedReceipts"],
    async (_key) => {
      return await fetchUploadedReceipts({
        activity_detail_id: activityData?.activity_detail_id, // TODO: This may be wrong?
      });
    },
    {
      enabled: !!activityData.activity_detail_id,
      initialData: { data: [] },
      onError: (error) => {
        handleResponse(error);
      },
    }
  );

  // Get Driver Data
  const {
    data: { data: drivers, isFetching: _isFetchingDriverData },
  } = useQuery(
    ["drivers", props.match.params.id],
    async () => {
      return fetchDrivers(props.match.params.id);
    },
    {
      initialData: { data: [] },
      onError: (error) => {
        handleResponse(error);
      },
    }
  );

  const mapsSelector = (e, address = "") => {
    e.preventDefault();
    if (
      /* if we're on iOS, open in Apple Maps */
      navigator.platform.indexOf("iPhone") !== -1 ||
      navigator.platform.indexOf("iPad") !== -1 ||
      navigator.platform.indexOf("iPod") !== -1
    ) {
      window.open(`maps://maps.google.com/maps?q=${address}`);
    } else {
      /* else use Google */
      window.open(`https://maps.google.com/maps?q=${address}`);
    }
  };

  const handleFileOpen = (e, url) => {
    if (!url) return;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const setModalOpen = (type, item) => {
    setModalIsOpen(true);
    setItemToDelete({ type, item });
  };

  const onConfirmDeleteClicked = () => {
    // Handles deleting receipts, attachments, and expenses.
    handleDelete(itemToDelete);
    setItemToDelete(null);
    setModalIsOpen(false);
  };

  const resetSelectedActivity = () => {
    // Triggered after editing an expense item.
    setEditActivity({});
    refetchActivityData();
  };

  // Submit Cost
  const { mutate: submitCost, isLoading: isAddingExpense } = useMutation(
    async (e) => {
      e.preventDefault();
      if (
        costData.fee_type_id &&
        Number(costData.cost) > 0 &&
        costData.payment_method_id
      ) {
        const data = {
          activity_item_cost: {
            fee_type_id: costData.fee_type_id,
            incurred_amount_or_hours: costData.cost,
            payment_method_id: costData.payment_method_id,
          },
        };
        return await createExpense(data, activityData?.id);
      }
      throw new Error("Select an expense type and enter a cost greater than zero.");
    },
    {
      onSuccess: (response) => {
        if (!response?.success) {
          handleResponse(response || {
            success: false,
            message: "Expense could not be added.",
          });
          return;
        }
        refetchActivityData();
        setCostData({ payment_method_id: 6 });
        toast.success("Expense added", { toastId: "expense-add-success" });
      },
      onError: (error) => {
        toast.error(error?.message || "Expense could not be added.");
      },
    }
  );

  // Upload Receipt
  const {
    mutate: handleReceiptUpload,
    isLoading: isUploadingReceipt,
  } = useMutation(
    async (file) => {
      const formdata = new FormData();
      formdata.append("activity_detail_id", activityData?.id);
      formdata.append("uploaded_data", file);

      const response = await uploadReceipt(formdata, {
        setUploadProgress,
      });

      if (!response?.success) {
        throw new Error(response?.message || "Receipt upload failed.");
      }
      return response;
    },
    {
      onSuccess: () => {
        refetchReceipts();
        refetchUploadedReceipts();
        toast.success("Receipt uploaded", {
          toastId: "receipt-upload-success",
        });
      },
      onError: (error) => {
        toast.error(error?.message || "Receipt upload failed.");
      },
      onSettled: () => {
        setUploadProgress(null);
        if (receiptRef.current) receiptRef.current.value = "";
      },
    }
  );

  // Upload attachments sequentially
  const {
    mutate: handleAttachmentChange,
    isLoading: isUploadingAttachment,
  } = useMutation(
    async (files) => {
      for (let index = 0; index < files.length; index += 1) {
        const formdata = new FormData();
        formdata.append("activity_id", activityData?.activity_id);
        formdata.append("uploaded_data", files[index]);

        const response = await uploadAttachment(formdata, {
          setUploadProgress: (progress) => {
            setUploadProgress(
              Math.floor(((index + progress / 100) / files.length) * 100)
            );
          },
        });

        if (!response?.success) {
          throw new Error(
            response?.message || "Attachment upload failed."
          );
        }
      }

      return files.length;
    },
    {
      onSuccess: (count) => {
        refetchAttachments();
        toast.success(
          count === 1 ? "Attachment uploaded" : "Attachments uploaded",
          { toastId: "attachment-upload-success" }
        );
      },
      onError: (error) => {
        refetchAttachments();
        toast.error(error?.message || "Attachment upload failed.");
      },
      onSettled: () => {
        setUploadProgress(null);
        if (attachmentRef.current) {
          attachmentRef.current.value = "";
        }
      },
    }
  );

  const handleCostChange = (e) => {
    const { value, name } = e.target;
    setCostData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Delete Expense
  const { mutate: _deleteExpense } = useMutation(
    async (item) => {
      return await deleteExpense(activityData.id, item.id);
    },
    {
      onSuccess: () => {
        refetchActivityData(props.match.params.id);
        attachmentRef.current.value = "";
      },
      onError: (error) => {
        handleResponse(error);
      },
    }
  );

  // Delete Receipt
  const { mutate: _deleteReceipt, isLoading: isDeleteReceiptLoading } =
    useMutation(
      async (item) => {
        if (item?.status === "processing") {
          return await deleteProcessingReceipts(item.id);
        }
        return await deleteReceipts(item.id);
      },
      {
        onSuccess: () => {
          refetchReceipts();
          refetchUploadedReceipts();
          receiptRef.current.value = "";
        },
        onError: (error) => {
          handleResponse(error);
        },
      }
    );

  // Delete Attachment
  const { mutate: _deleteAttachment, isLoading: isDeleteAttachmentLoading } =
    useMutation(
      async (item) => {
        return await deleteAttachment(item.id);
      },
      {
        onSuccess: () => {
          refetchAttachments();
          attachmentRef.current.value = "";
        },
        onError: (error) => {
          handleResponse(error);
        },
      }
    );

  const handleDelete = async ({ type, item }) => {
    if (type === "expense") {
      _deleteExpense(item);
    }
    if (type === "receipt") {
      _deleteReceipt(item);
    } else if (type === "attachment") {
      _deleteAttachment(item);
    }
  };

  const handleChange = (e) => {
    const { type, value, checked } = e.target;
    setActivityData((prevState) => ({
      ...prevState,
      [e.target.name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleFormSubmit = async (e, isStayOnPage = false) => {
    e.preventDefault();

    if (savingRef.current) return;

    savingRef.current = true;
    setIsSaving(true);

    try {
    const response = await updateActivity(
      {
        activity_detail: mask(activityData, updationKeys),
      },
      activityData?.id
    );
    handleResponse(response);

    if (response.success) {
      toast.success("Work order saved", {
        toastId: "activity-save-success",
      });
      if (!isStayOnPage) {
        let searchParams = "";
        if (queryParamsSelectedOffice && queryParamsSelectedDate) {
          searchParams = `?selected_office=${queryParamsSelectedOffice}&selected_date=${queryParamsSelectedDate}`;
        } else if (queryParamsSelectedOffice) {
          searchParams = `?selected_office=${queryParamsSelectedOffice}`;
        } else if (queryParamsSelectedDate) {
          searchParams = `?selected_date=${queryParamsSelectedDate}`;
        }
        history.push({
          pathname: "/",
          ...(searchParams && {
            search: searchParams,
          }),
        });
      }
    }
    } catch (error) {
      handleResponse({
        success: false,
        message: error?.message || "Unable to save work order.",
      });
    } finally {
      savingRef.current = false;
      setIsSaving(false);
    }
  };

  const handleExpenseUpdate = async (data) => {
    const response = await updateExpense(
      {
        fee_type_id: data.fee_type_id,
        payment_method_id: data.payment_method_id,
        incurred_amount_or_hours: data.cost,
      },
      activityData?.id,
      editACtivity.id
    );

    if (response.success) {
      setEditActivity({});
      refetchActivityData();
    }
    handleResponse(response);
    return response;
  };

  const handleSave = (e, isStayOnPage = false) => {
    if (editACtivity.id) {
      resetSelectedActivity();
    } else {
      handleFormSubmit(e, isStayOnPage);
    }
  };

  const handleCompletedByOnChange = (e) => {
    const value = e.target.value;

    const driverId = parseDriverSelection(value, drivers);
    if (driverId === undefined) return;

    setActivityData((prevState) => ({
      ...prevState,
      driver_id: driverId,
    }));
  };

  const convertToMonthDayYearWithTime = (date) => {
    const dateObj = new Date(date);
    var month = dateObj.getUTCMonth() + 1; //months from 1-12
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear();
    var hours = dateObj.getHours();
    var minutes = dateObj.getMinutes();
    var ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return `${month}/${day}/${year} ${strTime}`;
  };

  const completedByOptions = () => [
    <option key="no-driver" value=""></option>,
    ...drivers.map((driver) => (
      <option key={driver.id} value={driver.id}>
        {`${driver.last_name} ${driver.first_name}`}
      </option>
    )),
  ];

  const isLoading =
    _isFetchingDriverData ||
    _isFetchingReceiptData ||
    _isFetchingAttachmentData ||
    _isFetchingPaymentData ||
    _isFetchingPrepData ||
    _isFetchingFeeData ||
    _isFetchingActivityData;


  const getAttachmentType = (attachment) => {
    const filename = (
      attachment.filename ||
      attachment.file_name ||
      attachment.original_filename ||
      attachment.public_filename ||
      ""
    ).split("?")[0].toLowerCase();

    if (/\.(jpg|jpeg|png|gif|webp|heic)$/.test(filename)) {
      return "image";
    }
    if (/\.pdf$/.test(filename)) {
      return "pdf";
    }
    if (/\.(doc|docx)$/.test(filename)) {
      return "word";
    }
    return "file";
  };

  const receiptsToDisplay = [...receipts, ...uploadedReceipts];

  return (
    <div id="activityForm" className="activity-page-edit__container">
      {isLoading || isDeleteReceiptLoading || isDeleteAttachmentLoading ? (
        <Loader />
      ) : null}
      {uploadProgress ? <PercentageLoader percentage={uploadProgress} /> : null}
      {!editACtivity.id && (
        <FixedScrollHeader
          handleSave={handleSave}
          isSaving={isSaving}
        />
      )}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
        style={customModalStyles}
        contentLabel="Example Modal"
      >
        <h2>Confirmation</h2>
        <div>
          Are you sure you would like to delete this{" "}
          {itemToDelete?.type || "item"}?
        </div>
        <div
          style={{
            marginTop: "20px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <button
            className="btn btn-secondary"
            style={{ marginRight: "25px" }}
            onClick={() => setModalIsOpen(false)}
          >
            Close
          </button>
          <button
            className="btn btn-success"
            style={{ marginLeft: "25px" }}
            onClick={() => onConfirmDeleteClicked()}
          >
            Confirm
          </button>
        </div>
      </Modal>

      {editACtivity.id ? (
        <CostEditForm
          feeTypes={feeTypes}
          data={editACtivity}
          paymentMethods={paymentMethods}
          handleExpenseUpdate={handleExpenseUpdate}
          resetSelectedActivity={resetSelectedActivity}
        />
      ) : (
        <form
          className="activity-page-edit__form"
          onSubmit={(e) => handleFormSubmit(e)}
        >
          <div className="container mt-2">
            <section className="ds-workorder-summary">
              <div className="ds-workorder-summary__identifiers">
                <strong>
                  WO: {activityData?.work_order_number}
                </strong>
                <Link to={`/vehicle/${activityData?.vehicle_id}`}>
                  VIN: {activityData?.vin}
                </Link>
              </div>
              <h2 className="ds-workorder-summary__vehicle">
                {activityData?.vehicle_make_model}
              </h2>

              <div className="ds-workorder-summary__meta">
                <span className="ds-workorder-summary__type">
                  {activityData?.activity_type} |{" "}
                  {activityData?.activity_detail_type}
                </span>
                <time className="ds-workorder-summary__date">
                  {convertToMonthDayYear(activityData?.date)}
                </time>
              </div>

              <div className="ds-workorder-summary__details">
                {activityData?.alternate_to && (
                  <div className="ds-workorder-summary__name">
                    {activityData?.contact_id ? (
                      <Link to={`/contact/${activityData.contact_id}`}>
                        {activityData.alternate_to}
                      </Link>
                    ) : (
                      <span>{activityData.alternate_to}</span>
                    )}
                  </div>
                )}
                {activityData?.loan_reason && (
                  <div className="ds-workorder-summary__affiliation">
                    {activityData.loan_reason}
                  </div>
                )}
                {activityData?.phone && (
                  <div className="ds-workorder-summary__phone">
                    <a href={`tel:${activityData.phone}`}>
                      {activityData.phone}
                    </a>
                  </div>
                )}
                {(activityData?.street1 || activityData?.city) && (
                  <div className="ds-workorder-summary__address">
                    <button
                      type="button"
                      className="ds-address-link"
                      onClick={(e) =>
                        mapsSelector(
                          e,
                          `${activityData?.street1 || ""} ${activityData?.city || ""} ${activityData?.state_abbrev || ""}`
                        )
                      }
                    >
                      {[
                        activityData?.street1,
                        [activityData?.city, activityData?.state_abbrev !== "--" ? activityData?.state_abbrev : ""].filter(Boolean).join(", "),
                      ].filter(Boolean).join(", ")}
                    </button>
                  </div>
                )}
              </div>
            </section>

            {activityData?.work_order_instructions &&
              <div className="row mt-3">
                <div className="col">Delivery Instructions:</div>
              </div>
            }

            {activityData?.work_order_instructions && 
              <div className="row">
                <div className="col">
                  <TextareaAutosize
                    style={{
                      width: "100%",
                      overflow: "hidden",
                      resize: "none",
                      padding: "9px",
                      boxSizing: "border-box",
                    }}
                    value={activityData?.work_order_instructions ?? ""}
                    name="instructions"
                    disabled
                  />
                </div>
              </div>
            }

            <div className="row mt-3">
              <div className="col">Delivery Notes:</div>
            </div>

            <div className="row">
              <div className="col">
                <TextareaAutosize
                  style={{
                    width: "100%",
                    overflow: "hidden",
                    resize: "none",
                    padding: "9px",
                    boxSizing: "border-box",
                  }}
                  value={activityData?.notes ?? ""}
                  name="notes"
                  disabled
                />
              </div>
            </div>
            <div>
              <div className="ds-workorder-fields">
                <div className="ds-workorder-field">
                  <label htmlFor="completed_by">
                    Completed By
                  </label>
                  <select
                    id="completed_by"
                    name="completed_by"
                    value={activityData?.driver_id ?? ""}
                    onChange={handleCompletedByOnChange}
                  >
                    {completedByOptions()}
                  </select>
                </div>

                <div className="ds-workorder-mileage">
                  <div className="ds-workorder-field">
                    <label htmlFor="start_mileage">
                      Start Mileage
                    </label>
                    <input
                      id="start_mileage"
                      type="number"
                      name="start_mileage"
                      value={activityData?.start_mileage ?? ""}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="ds-workorder-field">
                    <label htmlFor="end_mileage">
                      End Mileage
                    </label>
                    <input
                      id="end_mileage"
                      type="number"
                      name="end_mileage"
                      value={activityData?.end_mileage ?? ""}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col">
                <label htmlFor="extra_prep_type_id">Extra Prep:</label>
                <select
                  name="extra_prep_type_id"
                  onChange={(e) => handleChange(e)}
                  value={activityData?.extra_prep_type_id ?? ""}
                >
                  {preps?.data?.map((prep) => {
                    return (
                      <option key={prep.id} value={prep.id}>
                        {prep.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>

            <div className="ds-inspection-row">
              <div className="col" style={{ padding: 0 }}>
                <div className="form-check form-check-inline">
                  <div className="form-check-label" htmlFor="exterior_checklist">
                    Exterior Check:
                  </div>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="exterior_checklist"
                    value="exterior_checklist"
                    name="exterior_checklist"
                    onChange={handleChange}
                    checked={Boolean(activityData?.exterior_checklist)}
                  />
                </div>
              </div>
              <div className="col">
                <div className="form-check form-check-inline">
                  <div className="form-check-label" htmlFor="interior_checklist">
                    Interior Check:
                  </div>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="interior_checklist"
                    value="interior_checklist"
                    name="interior_checklist"
                    onChange={handleChange}
                    checked={Boolean(activityData?.interior_checklist)}
                  />
                </div>
              </div>
              <div className="col">
                <div className="form-check form-check-inline">
                  <div className="form-check-label" htmlFor="driving_test">
                    Driving Test:
                  </div>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="driving_test"
                    value="driving_test"
                    name="driving_test"
                    onChange={handleChange}
                    checked={Boolean(activityData?.driving_test)}
                  />
                </div>
              </div>
            </div>
            <div className="row ds-expense-entry" hidden={activityData?.status !== 'open'}>
              <div className="col expense-field">
                <span>Expenses Type</span>
                <br />

                <select
                  key={
                    activityData?.activity_item_costs
                      ? activityData?.activity_item_costs.length
                      : 0
                  }
                  name="fee_type_id"
                  onChange={(e) => handleCostChange(e)}
                  value={costData.fee_type_id ?? ""}
                >
                  <option>Select item.</option>
                  {feeTypes.map((prep) => {
                    return (
                      <option key={prep.id} value={prep.id}>
                        {prep.name}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className="col cost-field">
                <span>Cost</span>
                <br />
                <input
                  key={
                    activityData?.activity_item_costs
                      ? activityData?.activity_item_costs.length
                      : 0
                  }
                  type="number"
                  onChange={(e) => handleCostChange(e)}
                  name="cost"
                  value={costData.cost ?? ""}
                  className="ds-expense-cost-input"
                />
                <button
                  type="button"
                  onClick={(e) => {
                    if (!isAddingExpense) submitCost(e);
                  }}
                  disabled={isAddingExpense}
                  className="btn btn-success ml-1 ds-expense-add"
                >
                  {isAddingExpense ? "..." : "+"}
                </button>
              </div>
            </div>

            <section className="ds-expense-list">
              <div className="ds-expense-list__heading">
                <strong>Recorded Expenses</strong>
                <span>
                  {activityData?.activity_item_costs?.length || 0} expenses
                </span>
              </div>

              {activityData?.activity_item_costs?.length > 0 ? (
                <>
                  {activityData.activity_item_costs.map((item) => (
                    <div className="ds-expense-card" key={item.id}>
                      <div className="ds-expense-card__top">
                        <strong>{item.fee_type}</strong>
                        <strong className="ds-expense-card__amount">
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                          }).format(Number(item.cost) || 0)}
                        </strong>
                      </div>

                      <div className="ds-expense-card__bottom">
                        <span>{item.payment_method}</span>

                        {activityData?.status === "open" && (
                          <div className="ds-expense-card__actions">
                            <button
                              type="button"
                              className="ds-expense-card__edit"
                              onClick={() => setEditActivity(item)}
                              aria-label={`Edit ${item.fee_type}`}
                            >
                              Edit
                            </button>

                            <button
                              type="button"
                              className="ds-expense-card__delete"
                              onClick={() => setModalOpen("expense", item)}
                              aria-label={`Delete ${item.fee_type}`}
                            >
                              Delete
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}

                  <div className="ds-expense-list__total">
                    <strong>Total Expenses</strong>
                    <strong>
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                      }).format(
                        activityData.activity_item_costs.reduce(
                          (total, item) => total + (Number(item.cost) || 0),
                          0
                        )
                      )}
                    </strong>
                  </div>
                </>
              ) : (
                <div className="ds-expense-list__empty">
                  No expenses recorded.
                </div>
              )}
            </section>

            <section className="ds-file-section">
              <div className="ds-file-section__heading">
                <div>
                  <h3>Receipts</h3>
                  <p>{receiptsToDisplay.length} uploaded</p>
                </div>

                <label className="ds-file-upload">
                  <span>{isUploadingReceipt ? "Uploading..." : "+ Add Receipt"}</span>
                  <input
                    type="file"
                    className="receipt-upload"
                    accept="image/png,image/gif,image/jpeg"
                    onChange={(e) => {
                      const file = e.target.files?.[0];
                      if (file && !isUploadingReceipt && !isUploadingAttachment) {
                        handleReceiptUpload(file);
                      }
                    }}
                    disabled={isUploadingReceipt || isUploadingAttachment}
                    ref={receiptRef}
                    aria-label="Upload receipt image"
                  />
                </label>
              </div>

              {receiptsToDisplay.length ? (
                <div className="ds-file-grid">
                  {receiptsToDisplay.map((receipt, index) => (
                    <div
                      className="ds-file-card"
                      key={receipt.id || `receipt-${index}`}
                    >
                      <button
                        type="button"
                        className="ds-file-card__preview"
                        onClick={(e) =>
                          handleFileOpen(e, receipt.public_filename)
                        }
                        aria-label={`View receipt ${index + 1}`}
                      >
                        <img
                          src={receipt.public_filename}
                          alt={`Receipt ${index + 1}`}
                        />
                      </button>
                      <div className="ds-file-card__footer">
                        <span>Receipt {index + 1}</span>
                        <button
                          type="button"
                          className="ds-file-card__delete"
                          onClick={() => setModalOpen("receipt", receipt)}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="ds-file-section__empty">
                  No receipts uploaded.
                </p>
              )}
            </section>

            <div className="row mt-2">
              <div className="col">
                <span>Damage / Driver Notes</span>
                <br />
              </div>

            </div>

            <div className="row mt-2">
              <div className="col">
                <textarea
                  rows="5"
                  className="ds-damage-notes"
                  value={activityData?.damage ?? ""}
                  name="damage"
                  onChange={handleChange}
                />
              </div>
            </div>

            <section className="ds-file-section">
              <div className="ds-file-section__heading">
                <div>
                  <h3>Attachments / Photos</h3>
                  <p>{attachments.length} uploaded</p>
                </div>

                <label className="ds-file-upload">
                  <span>{isUploadingAttachment ? "Uploading..." : "+ Add Files"}</span>
                  <input
                    type="file"
                    multiple
                    onChange={(e) => {
                      const files = Array.from(e.target.files || []);
                      if (
                        files.length &&
                        !isUploadingAttachment &&
                        !isUploadingReceipt
                      ) {
                        handleAttachmentChange(files);
                      }
                    }}
                    disabled={isUploadingReceipt || isUploadingAttachment}
                    ref={attachmentRef}
                    aria-label="Upload attachments or photos"
                  />
                </label>
              </div>

              {attachments.length ? (
                <div className="ds-file-grid">
                  {attachments.map((attachmentRecord, index) => {
                    const attachmentUrl = attachmentRecord.public_filename;

                    return (
                      <div
                        className="ds-file-card"
                        key={attachmentRecord.id || `attachment-${index}`}
                      >
                        <button
                          type="button"
                          className="ds-file-card__preview"
                          onClick={(e) => handleFileOpen(e, attachmentUrl)}
                          aria-label={`View attachment ${index + 1}`}
                        >
                          {getAttachmentType(attachmentRecord) === "image" ? (
                            <img
                              src={attachmentUrl}
                              alt={`Attachment ${index + 1}`}
                            />
                          ) : (
                            <div className="ds-file-card__document">
                              <span className="ds-file-card__document-icon">
                                {getAttachmentType(attachmentRecord) === "pdf"
                                  ? "PDF"
                                  : getAttachmentType(attachmentRecord) === "word"
                                  ? "DOC"
                                  : "FILE"}
                              </span>
                              <span>
                                {getAttachmentType(attachmentRecord) === "pdf"
                                  ? "PDF Document"
                                  : getAttachmentType(attachmentRecord) === "word"
                                  ? "Word Document"
                                  : "Attachment"}
                              </span>
                            </div>
                          )}
                        </button>
                        <div className="ds-file-card__footer">
                          <span>File {index + 1}</span>
                          <button
                            type="button"
                            className="ds-file-card__delete"
                            onClick={() =>
                              setModalOpen("attachment", attachmentRecord)
                            }
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <p className="ds-file-section__empty">
                  No attachments uploaded.
                </p>
              )}
            </section>
<section className="ds-inspection-guide">
              <h3>Inspection Instructions</h3>

              <details>
                <summary>Exterior Checklist</summary>
                <ul>
                  <li>No Exterior Damage</li>
                  <li>Spare tire/kit and tools</li>
                  <li>Fluid levels checked</li>
                  <li>Key Tagged Properly</li>
                  <li>
                    Tire Pressure{" "}
                    <strong>
                      {activityData?.front_wheel_psi}{" "}
                      {activityData?.rear_wheel_psi}
                    </strong>
                  </li>
                </ul>
              </details>

              <details>
                <summary>Interior Checklist</summary>
                <ul>
                  <li>No Interior Damage</li>
                  <li>Glovebox documents confirmed</li>
                  <li>Entertainment system tested & set</li>
                  <li>Climate control tested and set</li>
                  <li>
                    <strong>EV Charge Cable (if applicable)</strong>
                  </li>
                </ul>
              </details>

              <details>
                <summary>Driving Test</summary>
                <ul>
                  <li>No vehicle warning lights/faults</li>
                  <li>Does not pull left or right</li>
                  <li>Smooth shifting</li>
                  <li>Brakes checked</li>
                  <li>Vehicle performs as expected</li>
                </ul>
              </details>
            </section>
          </div>
        </form>
      )}
      <div style={{ textAlign: "center", fontSize: "12px" }}>
        {`Updated at: ${convertToMonthDayYearWithTime(
          activityData?.activity_updated_at
        )} by ${activityData?.activity_updated_by}`}
      </div>
    </div>
  );
};

export default Form;
